import i18n from "components/i18n/i18n";
import sislogUserGlobals from "components/UserGlobals";

export enum EnumDateInputType {
    date = "date",
    dateTime = "dateTime",
    dateWeekday = "dateWeekday",
    time = "time",
    timeSecond = "timeSecond",
}

export namespace EnumDateInputType {

    let formatterDate: any = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "UTC",
    };

    let formatterDateWithWeekDay: any = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        weekday: "narrow",
        timeZone: "UTC",
    };

    let formatterDateTime: any = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "UTC"
    };

    let formatterTime: any = {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC"
    };

    let formatterTimeSecond: any = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "UTC"
    };

    export function toEnumDateOutputType(type: string): EnumDateInputType {
        return (<any>EnumDateInputType)[type] ?? null;
    }

    export function toString(type: EnumDateInputType): string {
        return EnumDateInputType[type];
    }

    export function getFormatterOptions(type: EnumDateInputType): any {
        switch (type) {
            case EnumDateInputType.date:
                return formatterDate;
            case EnumDateInputType.dateWeekday:
                return formatterDateWithWeekDay;
            case EnumDateInputType.dateTime:
                return formatterDateTime;
            case EnumDateInputType.time:
                return formatterTime;
            case EnumDateInputType.timeSecond:
                return formatterTimeSecond;
            default:
                return formatterDate;
        }
    }

    export function getFormatterPattern(type: EnumDateInputType): string {
        switch (type) {
            case EnumDateInputType.date:
                return i18n.instance.t("daterangepicker.locale.format");
            case EnumDateInputType.dateTime:
                return i18n.instance.t("daterangepicker.locale.formatDateTime");
            case EnumDateInputType.dateWeekday:
                return null;
            case EnumDateInputType.time:
                return i18n.instance.t("daterangepicker.locale.formatTime");
            case EnumDateInputType.timeSecond:
                return i18n.instance.t("daterangepicker.locale.formatTimeSecond");
            default:
                return i18n.instance.t("daterangepicker.locale.format");
        }
    }

    export function getIntlDateTimeFormat(type: EnumDateInputType, locales?: string | string[]): Intl.DateTimeFormat {
        let formatterOpt = this.getFormatterOptions(type);
        return new Intl.DateTimeFormat(locales ?? sislogUserGlobals.language, formatterOpt);
    }
}